// ═══ 차량관리 크롬 — 검차 셸 사용자가 차량관리 화면(/main/<id>)을 볼 때 DashboardFull 의 사이드바·드로어 대신 그린다 ═══
// 상단 바(SimpleAppBar, '차량관리' 탭 활성) + 2차 바(ManageBar) + ≤768 하단 고정 5탭. 아래 헤더·화면은 DashboardFull 그대로.
// .dash-main 의 형제라 dir/lang(RTL·아랍 폰트)은 이 컨테이너 안에만 걸린다. 언어 서버 저장(putLocale)은 SimpleShell 과 같은 effect.
// props: { user, screenMode, onLogout, activeId }   activeId = navIdOf(am) — 2차 바 활성 항목
import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useT, useLocale } from '../../i18n/I18nProvider';
import { useIsMobile } from '../../utils/useMobile';
import { useIsDesktop } from './useDesktop';
import { putLocale } from './api';
import { SIMPLE_TABS, MANAGE_ITEMS, tabIdOf } from './routes';
import SimpleAppBar from './parts/SimpleAppBar';
import ManageBar from './parts/ManageBar';
import BottomTabs from './parts/BottomTabs';
import { BugReportBarButtons } from '../../components/BugReportButton';
import './simple.css';

function SimpleChrome(props) {
  var t = useT();
  var loc = useLocale();
  var isMobile = useIsMobile();
  var isDesktop = useIsDesktop();
  var navigate = useNavigate();
  var activeTab = tabIdOf(useLocation().pathname);
  // 마운트 시 + 언어 변경 시 서버에 저장 — SimpleShell.js 와 동일(크롬 변형에서 바꾼 언어도 푸시·메일에 반영).
  useEffect(function () { putLocale(loc.locale); }, [loc.locale]);
  // SimpleShell 과 같은 탭 배열 — 데스크톱은 '더보기' 를 회사명 드롭다운으로 옮긴다.
  var tabs = SIMPLE_TABS.filter(function (tab) {
    return !(isDesktop && tab.id === 'more');
  }).map(function (tab) {
    return { id: tab.id, label: t(tab.labelKey), onClick: function () { navigate(tab.to); } };
  });

  // 2차 바 클릭은 이동만 — DashboardFull 의 pathname effect 가 am·열린 탭을 잡는다.
  return (<div className="simple-shell ss-chrome" dir={loc.locale === 'ar' ? 'rtl' : 'ltr'} lang={loc.locale}>
    <SimpleAppBar user={props.user} screenMode={props.screenMode} onLogout={props.onLogout}
      tabs={tabs} activeTab={activeTab} isMobile={isMobile} isDesktop={isDesktop}
      extra={<BugReportBarButtons compact={isMobile} />} />
    <ManageBar items={MANAGE_ITEMS} activeId={props.activeId} onSelect={function (id) { navigate('/main/' + id); }} />
    {isMobile ? <BottomTabs items={tabs} activeId={activeTab} /> : null}
  </div>);
}

export default SimpleChrome;
